import { formatAnomalyApiDate } from "./anomalyDateUtils";

/**
 * Build route state for navigating to Metric Anomaly Timeline.
 * Omits empty optional fields; dates are normalized to YYYY-MM-DD.
 */
export const buildTimeSeriesNavState = ({
  metricId,
  metricName,
  periodFrom = null,
  periodTo = null,
  branchId = "",
  branchName = "",
  datapointId = "",
  datapointName = "",
  status = "",
  severity = "",
  ruleCode = "",
  selectedPeriod = "",
  fromDashboard = false,
  fromList = false,
} = {}) => {
  /** @type {Record<string, string|boolean>} */
  const state = {};

  if (metricId != null && metricId !== "") state.metricId = String(metricId);
  if (metricName) state.metricName = metricName;

  const from = formatAnomalyApiDate(periodFrom);
  const to = formatAnomalyApiDate(periodTo);
  if (from) state.periodFrom = from;
  if (to) state.periodTo = to;

  if (branchId) {
    state.branchId = String(branchId);
    if (branchName) state.branchName = branchName;
  }
  if (datapointId) {
    state.datapointId = String(datapointId);
    if (datapointName) state.datapointName = datapointName;
  }
  if (status) state.status = status;
  if (severity) state.severity = severity;
  if (ruleCode) state.ruleCode = ruleCode;
  if (selectedPeriod) state.selectedPeriod = selectedPeriod;
  if (fromDashboard) state.fromDashboard = true;
  if (fromList) state.fromList = true;

  return state;
};

/** @param {object} filters Current list filter snapshot */
export const buildListTimeSeriesNavState = (filters, overrides = {}) =>
  buildTimeSeriesNavState({
    periodFrom: filters.periodFrom,
    periodTo: filters.periodTo,
    branchId: filters.branchId,
    branchName: filters.branchName,
    status: filters.status,
    severity: filters.severity,
    ruleCode: filters.ruleCodes?.[0] || "",
    fromList: true,
    ...overrides,
  });

/** @param {object} filters Current dashboard filter snapshot */
export const buildDashboardTimeSeriesNavState = (filters, overrides = {}) =>
  buildTimeSeriesNavState({
    periodFrom: filters.periodFrom,
    periodTo: filters.periodTo,
    status: filters.status,
    fromDashboard: true,
    ...overrides,
  });
